// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-AgencyDetails-styles___paper--YUUbv {
  padding: 32px 32px 0;
  max-width: 736px;
  margin: 0 0 30px;
}

.components-AgencyDetails-styles___paperMax--zhF1Z {
  max-width: 1122px;
  margin: 0 0 30px;
}

.components-AgencyDetails-styles___loading--wjG7T {
  background: #f6f6f7;
  pointer-events: none;
}

.components-AgencyDetails-styles___inputContainer--hoH9P {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 32px;
}

.components-AgencyDetails-styles___inputWrapper--qzPRF {
  flex: 49% 0 1;
  padding: 8px 0 0;
}

.components-AgencyDetails-styles___buttons--_j5xg {
  border-top: 1px solid #dddee0;
  padding: 32px 0;
  display: flex;
  justify-content: flex-end;
}

.components-AgencyDetails-styles___buttons--_j5xg button {
    min-width: 97px;
    height: 34px;
  }

.components-AgencyDetails-styles___providerContainer--X8Sid {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
  padding-top: 16px;
  border-bottom: 1px solid #dddee0;
}

.components-AgencyDetails-styles___providerContainer--X8Sid button {
    min-width: 55px;
  }

.components-AgencyDetails-styles___providerContainer--X8Sid:last-child {
  border-bottom: none !important;
}

.components-AgencyDetails-styles___providerName--Tnr3G:first-letter {
  text-transform: capitalize;
}

.components-AgencyDetails-styles___providerName--Tnr3G {
  font-size: 15px;
}

.components-AgencyDetails-styles___providerName--Tnr3G svg {
    margin-left: 7px;
    vertical-align: bottom;
  }

.components-AgencyDetails-styles___providerTitle--pwnc8 {
  font-size: 21px;
  margin-bottom: 4px;
}

.components-AgencyDetails-styles___switch--xpzHM {
  padding-bottom: 0;
}

.components-AgencyDetails-styles___switch--xpzHM h2 {
    margin-bottom: 10px;
    font-weight: 600 !important;
  }

.components-AgencyDetails-styles___switch--xpzHM .components-AgencyDetails-styles___tableCell--XVO2p {
    font-size: 15px !important;
    color: #1b2432 !important;
  }

.components-AgencyDetails-styles___switch--xpzHM .components-AgencyDetails-styles___tableCell--XVO2p:first-child {
      line-height: 13px;
      padding-bottom: 15px;
      padding-top: 20px !important;
      font-weight: 600;
      padding-right: 0 !important;
      font-size: 17px !important;
    }

.components-AgencyDetails-styles___switch--xpzHM .components-AgencyDetails-styles___tableCell--XVO2p .components-AgencyDetails-styles___description--Rpvmf::before {
      content: '\\A';
      white-space: pre;
    }

.components-AgencyDetails-styles___switch--xpzHM .components-AgencyDetails-styles___tableCell--XVO2p .components-AgencyDetails-styles___description--Rpvmf {
      font-size: 13px;
      color: #1b2432;
      font-weight: normal;
      min-width: 307px;
      line-height: 11px;
    }

.components-AgencyDetails-styles___switch--xpzHM .components-AgencyDetails-styles___tableCell--XVO2p .components-AgencyDetails-styles___descriptionReimburs--mIOM9::before {
      content: '\\A';
      white-space: pre;
    }

.components-AgencyDetails-styles___switch--xpzHM .components-AgencyDetails-styles___tableCell--XVO2p .components-AgencyDetails-styles___descriptionReimburs--mIOM9 {
      font-size: 13px;
      color: #1b2432;
      font-weight: normal;
      max-width: 271px;
      line-height: 15px;
      overflow-wrap: break-word;
      white-space: normal;
    }

.components-AgencyDetails-styles___switch--xpzHM .components-AgencyDetails-styles___fraud--Exog5 {
    width: 270px;
    max-width: 270px;
    padding-right: 25px !important;
  }

.components-AgencyDetails-styles___switch--xpzHM .components-AgencyDetails-styles___fraudSelect--u6ljx {
    width: 330px;
    text-align: right;
    padding: 0 !important;
    width: 100px;
  }

.components-AgencyDetails-styles___switch--xpzHM .components-AgencyDetails-styles___inputWrapper--qzPRF div {
      min-width: 280px;
    }

.components-AgencyDetails-styles___switch--xpzHM .components-AgencyDetails-styles___inputWrapper--qzPRF .components-AgencyDetails-styles___marginNormal--zdgdb {
      width: 330px;
    }

.components-AgencyDetails-styles___switch--xpzHM .components-AgencyDetails-styles___recommended--nSRF0 {
    background: rgba(18, 218, 159, 0.1);
    border: 1px solid #12da9f;
    border-radius: 4px;
    width: 105px !important;
    height: 24px;
    font-size: 13px;
    color: #1b2432;
    letter-spacing: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

.components-AgencyDetails-styles___switch--xpzHM .components-AgencyDetails-styles___recommendedItemContainer--QNElC {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

.components-AgencyDetails-styles___switch--xpzHM .components-AgencyDetails-styles___recommendedItemFraud--IqzS7 {
    margin-right: 45px;
  }

.components-AgencyDetails-styles___switch--xpzHM .components-AgencyDetails-styles___tableRow--gGi9k {
    height: 68px !important;
    vertical-align: center;
  }

.components-AgencyDetails-styles___switch--xpzHM .components-AgencyDetails-styles___tableRow--gGi9k td:first-child {
      padding-left: 0 !important;
    }

.components-AgencyDetails-styles___switch--xpzHM .components-AgencyDetails-styles___tableRow--gGi9k:first-child {
      padding-bottom: 20px !important;
    }

.components-AgencyDetails-styles___switch--xpzHM .components-AgencyDetails-styles___tableRow--gGi9k:last-child .components-AgencyDetails-styles___tableCell--XVO2p {
        border: none;
      }

.components-AgencyDetails-styles___switch--xpzHM tr:last-child td {
      padding-bottom: 0 !important;
    }

.components-AgencyDetails-styles___dialogBox--yVfuS {
  min-width: 700px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.components-AgencyDetails-styles___dialogBox--yVfuS .components-AgencyDetails-styles___title--wOBrz {
    font-size: 25px;
    min-width: 700px;
    display: flex;
    flex: 1 0 auto;
    padding: 32px;
    padding-bottom: 12px;
  }

.components-AgencyDetails-styles___dialogBox--yVfuS .components-AgencyDetails-styles___title--wOBrz .components-AgencyDetails-styles___closeIcon--VmG3B {
      position: absolute;
      top: 20px;
      right: 20px;
    }

.components-AgencyDetails-styles___dialogBox--yVfuS .components-AgencyDetails-styles___title--wOBrz .components-AgencyDetails-styles___closeIcon--VmG3B .components-AgencyDetails-styles___svg--veHM1 {
        font-size: 26px;
      }

.components-AgencyDetails-styles___dialogBox--yVfuS .components-AgencyDetails-styles___popupBody--etLN7 {
    min-width: 700px;
    padding: 32px;
    padding-top: 0;
  }

.components-AgencyDetails-styles___dialogBox--yVfuS .components-AgencyDetails-styles___confirmationPopupButton--uVXLI {
    border-top: 1px solid rgba(224, 224, 224, 1);
    margin: 32px;
    margin-top: 0;
    padding-top: 32px;
    display: flex;
    justify-content: flex-end;
  }

.components-AgencyDetails-styles___dialogBox--yVfuS .components-AgencyDetails-styles___confirmationPopupButton--uVXLI button {
      background: #318afb;
      border-radius: 6px;
      width: 200px;
      height: 52px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'Roboto';
      font-size: 17px;
      color: #ffffff;
      letter-spacing: 0;
    }

.components-AgencyDetails-styles___dialogBox--yVfuS .components-AgencyDetails-styles___confirmationPopupButton--uVXLI button:disabled {
      opacity: 0.12 !important;
    }

.components-AgencyDetails-styles___iOSBar--PcYCq,
.components-AgencyDetails-styles___iOSBarON--kFDLz {
  border-radius: 35px !important;
  width: 72px !important;
  height: 32px !important;
  margin-top: -15px !important;
  background-color: #6d717a !important;
  opacity: 1 !important;
  margin-left: -32px !important;
}

.components-AgencyDetails-styles___disabled--u3A4u + span {
  opacity: 0.12 !important;
}

.components-AgencyDetails-styles___iOSBar--PcYCq:before {
  content: attr(title) 'OFF';
  color: white !important;
  position: relative !important;
  top: 4px !important;
  right: 9px !important;
  font-size: 15px !important;
  letter-spacing: 0 !important;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
}

.components-AgencyDetails-styles___iOSBarON--kFDLz:before {
  content: attr(title) 'ON';
  color: white !important;
  position: relative !important;
  top: 4px !important;
  left: -38px !important;
  font-size: 15px !important;
  letter-spacing: 0 !important;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
}

.components-AgencyDetails-styles___iOSIcon--rcxkn {
  width: 24px !important;
  height: 24px !important;
  background-color: white !important;
}

.components-AgencyDetails-styles___iOSIconChecked--MzTT7 {
  boxshadow: theme.shadows[1] !important;
  content: attr(title) 'ON' !important;
}

.components-AgencyDetails-styles___iOSSwitchBase--npc_6 {
  width: 31px !important;
}

.components-AgencyDetails-styles___iOSSwitchBase--npc_6 .components-AgencyDetails-styles___iOSChecked--i3gqD {
    color: green;
  }

.components-AgencyDetails-styles___iOSSwitchBase--npc_6 .components-AgencyDetails-styles___iOSChecked--i3gqD + \$iOSBar {
      background-color: red;
    }

.components-AgencyDetails-styles___iOSChecked--i3gqD {
  transform: translateX(35px) !important;
  width: 38px !important;
}

.components-AgencyDetails-styles___iOSChecked--i3gqD + .components-AgencyDetails-styles___iOSBarON--kFDLz {
    opacity: 1 !important;
    background-color: #318afb !important;
    border: none !important;
  }

.components-AgencyDetails-styles___iOSChecked--i3gqD.components-AgencyDetails-styles___iOSBarON--kFDLz {
    background-color: '#318AFB' !important;
  }

.components-AgencyDetails-styles___colorPrimary--b5kJ2 {
  color: #318afb;
  width: 31px;
  margin-top: 1px !important;
}

.components-AgencyDetails-styles___loaderWrapper--U_oXd {
  position: relative !important;
}

.components-AgencyDetails-styles___tableCell--XVO2p.components-AgencyDetails-styles___buttonCell--GBeFB {
  text-align: right;
  padding: 0 !important;
  width: 100px;
}

.components-AgencyDetails-styles___loading--wjG7T {
  pointer-events: none;
}

.components-AgencyDetails-styles___component--jM1DF {
  padding: 0 !important;
  max-width: unset;
  margin: unset;
  border: none !important;
  box-shadow: none !important;
}

.components-AgencyDetails-styles___agencySetting--askWB {
  padding-bottom: 0;
}

.components-AgencyDetails-styles___agencySetting--askWB h2 {
    margin-bottom: 10px;
    font-weight: 600 !important;
  }

.components-AgencyDetails-styles___tab--ZhJqZ {
  border-bottom: 1px solid #c6c8cc !important;
}

.components-AgencyDetails-styles___tab--ZhJqZ span {
    text-transform: none;
    font-size: 17px;
  }

.components-AgencyDetails-styles___tabs--tfMXg {
  margin-bottom: 6px !important;
}

.components-AgencyDetails-styles___inputContainerPop--VZfu2 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.components-AgencyDetails-styles___colorpickerContainer--CPH2k {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px;
  border: 1px solid #e0e2e6;
  border-radius: 4px;
  min-width: 123px;
}

.components-AgencyDetails-styles___colorPickerInput--QCgzH input {
    border: none !important;
    font-size: 15px;
    color: #1b2432;
    letter-spacing: 0;
    width: 85px;
  }

.components-AgencyDetails-styles___colorpickerError--QNlG_ {
  text-align: end;
  font-size: 13px;
  color: #ff0000;
  margin-top: 3px;
}

.components-AgencyDetails-styles___colorpickerErrorRow--F_I0y {
  padding-bottom: 3px !important;
}

.components-AgencyDetails-styles___colorpickerRowCont--zPMfC {
  display: flex;
  justify-content: space-between;
}

.components-AgencyDetails-styles___colorpickerRowCont--zPMfC input {
    width: 85px;
    line-height: normal;
  }

.components-AgencyDetails-styles___pickerStyle--EwN69 {
  position: absolute;
  z-index: 9999;
}

.components-AgencyDetails-styles___colorpickerRowText--ZOwmf {
  font-size: 15px;
  color: #1b2432;
  letter-spacing: 0;
  margin-bottom: 9px;
  font-weight: 600;
}

.components-AgencyDetails-styles___colorpickerRowDescription--NESJY {
  font-size: 13px;
  color: #1b2432;
  letter-spacing: 0;
}

.components-AgencyDetails-styles___colorpickerRow--I35s9 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 24px;
  padding-top: 24px;
  border-bottom: 1px solid #d8d8d8;
}

.components-AgencyDetails-styles___textFieldBox--w3fEL {
  display:flex;
  align-items: center;
  margin-bottom: 10px;
  position: relative;
}

.components-AgencyDetails-styles___colorPreview--_EITn {
  width: 24px;
  height: 24px; 
  border-radius: 4px;
  margin-right: 5px;
}

.components-AgencyDetails-styles___flexbox-fix--wLueP:nth-of-type(3) {
  display:none;
}

#components-AgencyDetails-styles___rc-editable-input-1--uIGKM, 
#components-AgencyDetails-styles___rc-editable-input-2--rYYSH,
#components-AgencyDetails-styles___rc-editable-input-3--Uvh0O,
#components-AgencyDetails-styles___rc-editable-input-4--azMXe, 
#components-AgencyDetails-styles___rc-editable-input-5--zwAfE {
  width: 100% !important;
}

.components-AgencyDetails-styles___colorpickerRow--I35s9:last-child {
  border-bottom: none !important;
}

.components-AgencyDetails-styles___colorpickerRowTextContainer--xedrg {
  display: flex;
  flex-direction: column;
  align-items: baseline;
}

.components-AgencyDetails-styles___colorPickerStyle--p83FE span {
  border: none !important;
  width: 24px !important;
  height: 24px !important;
  box-shadow: none !important;
  border-radius: 4px !important;
  display: block;
}

.components-AgencyDetails-styles___colorPickerStyle--p83FE {
  height: 24px;
  margin-right: 5px;
}

.components-AgencyDetails-styles___companyInfoHeader--e3q3i {
  display: flex;
}

.components-AgencyDetails-styles___companyInfoHeaderText--xwMGf h2 {
  font-size: 21px;
  color: #1b2432;
  letter-spacing: 0;
  margin-bottom: 5px;
}

.components-AgencyDetails-styles___companyInfoHeaderText--xwMGf .components-AgencyDetails-styles___description--Rpvmf {
  font-size: 13px;
  color: #6d717a;
  letter-spacing: 0;
}

.components-AgencyDetails-styles___companyInfoContainer--wxrtB {
  border: 1px solid #dddee0;
  border-radius: 4px;
  padding-top: 25px;
  padding-bottom: 17px;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 32px;
  margin-top: 18px;
}

.components-AgencyDetails-styles___companyInfoContainerRow--jFIf0 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.components-AgencyDetails-styles___contactInfoData--L2hCD {
  display: flex;
}

.components-AgencyDetails-styles___companyInfoColumn--pp9o7 {
  margin-right: 36px;
}

.components-AgencyDetails-styles___companyInfoColumn--pp9o7 .components-AgencyDetails-styles___descr--KJCk1:first-child {
      padding-bottom: 6px;
    }

.components-AgencyDetails-styles___contactContainer--YmAVO {
  display: flex;
}

.components-AgencyDetails-styles___contactButtonWrapper--anJN8 {
  display: flex;
  justify-content: flex-end;
  flex: 1;
}

.components-AgencyDetails-styles___companyInfoHeaderText--xwMGf {
  font-size: 15px;
  color: #1b2432;
  letter-spacing: 0;
  margin-left: 22px;
}

.components-AgencyDetails-styles___companyInfoContainerDetails--paCRH {
  display: flex;
  align-items: center;
}

.components-AgencyDetails-styles___descr--KJCk1 {
  font-size: 13px;
  color: #6d717a;
  letter-spacing: 0;
  line-height: 20px;
  display: flex;
  align-items: center;
}

.components-AgencyDetails-styles___descr--KJCk1 p,
  .components-AgencyDetails-styles___descr--KJCk1 span {
    color: #1b2432;
    letter-spacing: 0;
    padding-left: 5px;
  }

.components-AgencyDetails-styles___buttonEdit--cKnrm {
  width: 55px;
  min-width: 55px !important;
}

.components-AgencyDetails-styles___companyInfoHeaderIconContainer--fCLJL {
  background: #1b2432;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.components-AgencyDetails-styles___companyInfoDescription--bH_Zw {
  text-align: left;
  font-size: 15px;
  color: #6d717a;
  letter-spacing: 0;
  padding: 0 32px 15px 32px;
  font-family: 'Roboto';
  width: 700px;
}

.components-AgencyDetails-styles___popupButtonsContainer--BBDNF {
  text-align: right;
  margin-left: 32px;
  margin-right: 32px;
  padding: 32px 0;
  border-top: 1px solid #d8d8d8;
  margin-top: 28px;
}

.components-AgencyDetails-styles___compPopupButton--LQrE8 {
  background: #318afb;
  border-radius: 6px;
  font-family: 'Roboto';
  font-size: 17px;
  color: #ffffff;
  letter-spacing: 0;
  width: 200px;
  text-align: center;
  height: 52px;
}

.components-AgencyDetails-styles___dialogBox--yVfuS {
  min-width: 700px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.components-AgencyDetails-styles___dialogBox--yVfuS .components-AgencyDetails-styles___title--wOBrz {
    font-size: 29px;
    color: #1b2432;
    background-color: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: 1 0 auto;
    padding: 32px 32px 0;
    padding-bottom: 12px;
  }

.components-AgencyDetails-styles___dialogBox--yVfuS .components-AgencyDetails-styles___title--wOBrz .components-AgencyDetails-styles___closeIcon--VmG3B {
      position: absolute;
      top: 18px;
      right: 18px;
    }

.components-AgencyDetails-styles___dialogBox--yVfuS .components-AgencyDetails-styles___title--wOBrz .components-AgencyDetails-styles___closeIcon--VmG3B .components-AgencyDetails-styles___svg--veHM1 {
        font-size: 26px;
      }

.components-AgencyDetails-styles___dialogBox--yVfuS .components-AgencyDetails-styles___container--FAbFF {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 32px;
    margin-bottom: 0px;
    padding-bottom: 32px;
    border-bottom: 1px solid #e0e2e6;
  }

.components-AgencyDetails-styles___dialogBox--yVfuS .components-AgencyDetails-styles___container--FAbFF .components-AgencyDetails-styles___textField--I5KRQ {
      margin: 18px 0 14px !important;
    }

.components-AgencyDetails-styles___dialogBox--yVfuS .components-AgencyDetails-styles___inputContainer--hoH9P {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-left: 30px;
    padding-right: 30px;
    max-width: 636px;
    max-width: 700px;
    margin-top: 0px;
    margin-bottom: 0;
    padding-bottom: 0;
    font-family: 'Roboto';
  }

.components-AgencyDetails-styles___dialogBox--yVfuS .components-AgencyDetails-styles___inputWrapper--qzPRF {
    flex: 49% 0 1;
    padding: 0;
  }

.components-AgencyDetails-styles___rateContainer--wxljk {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid rgba(224, 224, 224, 1);
}

.components-AgencyDetails-styles___rateContainer--wxljk .components-AgencyDetails-styles___description--Rpvmf {
    font-size: 13px;
    color: #1b2432;
    font-weight: normal;
    line-height: 11px;
    margin-top: 8px;
    margin-bottom: 13px;
  }

.components-AgencyDetails-styles___rateContainer--wxljk .components-AgencyDetails-styles___labelName--E5TVP {
    legaline-height: 13px;
    font-weight: 600;
    font-size: 17px !important;
    color: #1b2432 !important;
  }

.components-AgencyDetails-styles___disabledAgencyName--VAC2H {
  font-family: Roboto;
  font-style: italic;
  font-size: 15px;
  color: #1b2432;
  letter-spacing: 0;
}

.components-AgencyDetails-styles___companyInfoContainerDetails--paCRH {
  align-items: flex-start;
  max-width: 600px;
  flex-wrap: wrap;
  flex-direction: column;
}

.components-AgencyDetails-styles___companyInfoContainerDetails--paCRH p {
    margin-top: 4px !important;
    margin-bottom: 4px !important;
  }

.components-AgencyDetails-styles___companyInfoAddress--pe1QT {
  margin-top: 3px;
}

.components-AgencyDetails-styles___companyInfoAddress--pe1QT .components-AgencyDetails-styles___descr--KJCk1 {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

.components-AgencyDetails-styles___companyInfoAddress--pe1QT .components-AgencyDetails-styles___descr--KJCk1 div {
  display: flex;
  line-height: 11px;
}

.components-AgencyDetails-styles___companyInfoAddress--pe1QT .components-AgencyDetails-styles___descr--KJCk1 div:empty {
  display: none;
}

.components-AgencyDetails-styles___companyInfoAddress--pe1QT .components-AgencyDetails-styles___descr--KJCk1 .components-AgencyDetails-styles___infCont--s7zTw {
  flex-direction: column;
}

.components-AgencyDetails-styles___informationTitleCompany--__Jel {
  margin-left: 32px;
  margin-top: 25px;
  margin-bottom: 10px;
}

.components-AgencyDetails-styles___inputWrapper100--Hr75c {
  flex: 100%;
}
`, "",{"version":3,"sources":["webpack://./components/AgencyDetails/styles.pcss"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,yBAAyB;AAM3B;;AAJE;IACE,eAAe;IACf,YAAY;EACd;;AAGF;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,gCAAgC;AAKlC;;AAHE;IACE,eAAe;EACjB;;AAGF;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AAMjB;;AAJE;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;AAGF;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AAmHnB;;AAjHE;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;;AAEA;IACE,0BAA0B;IAC1B,yBAAyB;EAqC3B;;AAnCE;MACE,iBAAiB;MACjB,oBAAoB;MACpB,4BAA4B;MAC5B,gBAAgB;MAChB,2BAA2B;MAC3B,0BAA0B;IAC5B;;AAEA;MACE,aAAa;MACb,gBAAgB;IAClB;;AACA;MACE,eAAe;MACf,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,iBAAiB;IACnB;;AAEA;MACE,aAAa;MACb,gBAAgB;IAClB;;AAEA;MACE,eAAe;MACf,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,iBAAiB;MACjB,yBAAyB;MACzB,mBAAmB;IACrB;;AAGF;IACE,YAAY;IACZ,gBAAgB;IAChB,8BAA8B;EAChC;;AACA;IACE,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;EACd;;AAGE;MACE,gBAAgB;IAClB;;AACA;MACE,YAAY;IACd;;AAGF;IACE,mCAAmC;IACnC,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;AAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;EACb;;AACA;IACE,kBAAkB;EACpB;;AACA;IACE,uBAAuB;IACvB,sBAAsB;EAexB;;AAbE;MACE,0BAA0B;IAC5B;;AAEA;MACE,+BAA+B;IACjC;;AAGE;QACE,YAAY;MACd;;AAIF;MACE,4BAA4B;IAC9B;;AAIJ;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AAoDzB;;AAlDE;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,aAAa;IACb,oBAAoB;EAWtB;;AATE;MACE,kBAAkB;MAClB,SAAS;MACT,WAAW;IAKb;;AAHE;QACE,eAAe;MACjB;;AAIJ;IACE,gBAAgB;IAChB,aAAa;IACb,cAAc;EAChB;;AAEA;IACE,4CAA4C;IAC5C,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,yBAAyB;EAkB3B;;AAhBE;MACE,mBAAmB;MACnB,kBAAkB;MAClB,YAAY;MACZ,YAAY;MACZ,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,qBAAqB;MACrB,eAAe;MACf,cAAc;MACd,iBAAiB;IACnB;;AACA;MACE,wBAAwB;IAC1B;;AAIJ;;EAEE,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,oCAAoC;EACpC,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;EAC1B,4BAA4B;EAC5B,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;EAC5B,uDAAuD;AACzD;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kCAAkC;AACpC;;AACA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AAOxB;;AANE;IACE,YAAY;EAId;;AAHE;MACE,qBAAqB;IACvB;;AAIJ;EACE,sCAAsC;EACtC,sBAAsB;AAMxB;;AALE;IACE,qBAAqB;IACrB,oCAAoC;IACpC,uBAAuB;EACzB;;AAIA;IACE,sCAAsC;EACxC;;AAGF;EACE,cAAc;EACd,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AAMnB;;AAJE;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;;AAGF;EACE,2CAA2C;AAK7C;;AAJE;IACE,oBAAoB;IACpB,eAAe;EACjB;;AAEF;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAGE;IACE,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,WAAW;EACb;;AAGF;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AACA;EACE,aAAa;EACb,8BAA8B;AAMhC;;AAJE;IACE,WAAW;IACX,mBAAmB;EACrB;;AAGF;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,oBAAoB;EACpB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;EAKE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,cAAc;AAChB;;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AAOpB;;AAJI;MACE,mBAAmB;IACrB;;AAIJ;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,OAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AAQrB;;AANE;;IAEE,cAAc;IACd,iBAAiB;IACjB,iBAAiB;EACnB;;AAGF;EACE,WAAW;EACX,0BAA0B;AAC5B;;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AAwDzB;;AAtDE;IACE,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,oBAAoB;EAWtB;;AATE;MACE,kBAAkB;MAClB,SAAS;MACT,WAAW;IAKb;;AAHE;QACE,eAAe;MACjB;;AAIJ;IACE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,gCAAgC;EAKlC;;AAHE;MACE,8BAA8B;IAChC;;AAGF;IACE,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;EACvB;;AAEA;IACE,aAAa;IACb,UAAU;EACZ;;AAGF;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;AAgB9C;;AAdE;IACE,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;EACrB;;AACA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,0BAA0B;IAC1B,yBAAyB;EAC3B;;AAGF;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AAMxB;;AAJE;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;AAGF;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".paper {\n  padding: 32px 32px 0;\n  max-width: 736px;\n  margin: 0 0 30px;\n}\n\n.paperMax {\n  max-width: 1122px;\n  margin: 0 0 30px;\n}\n\n.loading {\n  background: #f6f6f7;\n  pointer-events: none;\n}\n\n.inputContainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding-bottom: 32px;\n}\n\n.inputWrapper {\n  flex: 49% 0 1;\n  padding: 8px 0 0;\n}\n\n.buttons {\n  border-top: 1px solid #dddee0;\n  padding: 32px 0;\n  display: flex;\n  justify-content: flex-end;\n\n  button {\n    min-width: 97px;\n    height: 34px;\n  }\n}\n\n.providerContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 16px;\n  padding-top: 16px;\n  border-bottom: 1px solid #dddee0;\n\n  button {\n    min-width: 55px;\n  }\n}\n\n.providerContainer:last-child {\n  border-bottom: none !important;\n}\n\n.providerName:first-letter {\n  text-transform: capitalize;\n}\n\n.providerName {\n  font-size: 15px;\n\n  svg {\n    margin-left: 7px;\n    vertical-align: bottom;\n  }\n}\n\n.providerTitle {\n  font-size: 21px;\n  margin-bottom: 4px;\n}\n\n.switch {\n  padding-bottom: 0;\n\n  h2 {\n    margin-bottom: 10px;\n    font-weight: 600 !important;\n  }\n\n  .tableCell {\n    font-size: 15px !important;\n    color: #1b2432 !important;\n\n    &:first-child {\n      line-height: 13px;\n      padding-bottom: 15px;\n      padding-top: 20px !important;\n      font-weight: 600;\n      padding-right: 0 !important;\n      font-size: 17px !important;\n    }\n\n    .description::before {\n      content: '\\A';\n      white-space: pre;\n    }\n    .description {\n      font-size: 13px;\n      color: #1b2432;\n      font-weight: normal;\n      min-width: 307px;\n      line-height: 11px;\n    }\n\n    .descriptionReimburs::before {\n      content: '\\A';\n      white-space: pre;\n    }\n\n    .descriptionReimburs {\n      font-size: 13px;\n      color: #1b2432;\n      font-weight: normal;\n      max-width: 271px;\n      line-height: 15px;\n      overflow-wrap: break-word;\n      white-space: normal;\n    }\n  }\n\n  .fraud {\n    width: 270px;\n    max-width: 270px;\n    padding-right: 25px !important;\n  }\n  .fraudSelect {\n    width: 330px;\n    text-align: right;\n    padding: 0 !important;\n    width: 100px;\n  }\n\n  .inputWrapper {\n    div {\n      min-width: 280px;\n    }\n    .marginNormal {\n      width: 330px;\n    }\n  }\n\n  .recommended {\n    background: rgba(18, 218, 159, 0.1);\n    border: 1px solid #12da9f;\n    border-radius: 4px;\n    width: 105px !important;\n    height: 24px;\n    font-size: 13px;\n    color: #1b2432;\n    letter-spacing: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .recommendedItemContainer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n  }\n  .recommendedItemFraud {\n    margin-right: 45px;\n  }\n  .tableRow {\n    height: 68px !important;\n    vertical-align: center;\n\n    td:first-child {\n      padding-left: 0 !important;\n    }\n\n    &:first-child {\n      padding-bottom: 20px !important;\n    }\n\n    &:last-child {\n      .tableCell {\n        border: none;\n      }\n    }\n  }\n  tr:last-child {\n    td {\n      padding-bottom: 0 !important;\n    }\n  }\n}\n\n.dialogBox {\n  min-width: 700px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n\n  .title {\n    font-size: 25px;\n    min-width: 700px;\n    display: flex;\n    flex: 1 0 auto;\n    padding: 32px;\n    padding-bottom: 12px;\n\n    .closeIcon {\n      position: absolute;\n      top: 20px;\n      right: 20px;\n\n      .svg {\n        font-size: 26px;\n      }\n    }\n  }\n\n  .popupBody {\n    min-width: 700px;\n    padding: 32px;\n    padding-top: 0;\n  }\n\n  .confirmationPopupButton {\n    border-top: 1px solid rgba(224, 224, 224, 1);\n    margin: 32px;\n    margin-top: 0;\n    padding-top: 32px;\n    display: flex;\n    justify-content: flex-end;\n\n    button {\n      background: #318afb;\n      border-radius: 6px;\n      width: 200px;\n      height: 52px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-family: 'Roboto';\n      font-size: 17px;\n      color: #ffffff;\n      letter-spacing: 0;\n    }\n    button:disabled {\n      opacity: 0.12 !important;\n    }\n  }\n}\n\n.iOSBar,\n.iOSBarON {\n  border-radius: 35px !important;\n  width: 72px !important;\n  height: 32px !important;\n  margin-top: -15px !important;\n  background-color: #6d717a !important;\n  opacity: 1 !important;\n  margin-left: -32px !important;\n}\n\n.disabled + span {\n  opacity: 0.12 !important;\n}\n\n.iOSBar:before {\n  content: attr(title) 'OFF';\n  color: white !important;\n  position: relative !important;\n  top: 4px !important;\n  right: 9px !important;\n  font-size: 15px !important;\n  letter-spacing: 0 !important;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n}\n\n.iOSBarON:before {\n  content: attr(title) 'ON';\n  color: white !important;\n  position: relative !important;\n  top: 4px !important;\n  left: -38px !important;\n  font-size: 15px !important;\n  letter-spacing: 0 !important;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n}\n\n.iOSIcon {\n  width: 24px !important;\n  height: 24px !important;\n  background-color: white !important;\n}\n.iOSIconChecked {\n  boxshadow: theme.shadows[1] !important;\n  content: attr(title) 'ON' !important;\n}\n\n.iOSSwitchBase {\n  width: 31px !important;\n  & .iOSChecked {\n    color: green;\n    & + $iOSBar {\n      background-color: red;\n    }\n  }\n}\n\n.iOSChecked {\n  transform: translateX(35px) !important;\n  width: 38px !important;\n  & + .iOSBarON {\n    opacity: 1 !important;\n    background-color: #318afb !important;\n    border: none !important;\n  }\n}\n\n.iOSChecked {\n  &.iOSBarON {\n    background-color: '#318AFB' !important;\n  }\n}\n\n.colorPrimary {\n  color: #318afb;\n  width: 31px;\n  margin-top: 1px !important;\n}\n\n.loaderWrapper {\n  position: relative !important;\n}\n\n.tableCell.buttonCell {\n  text-align: right;\n  padding: 0 !important;\n  width: 100px;\n}\n\n.loading {\n  pointer-events: none;\n}\n\n.component {\n  padding: 0 !important;\n  max-width: unset;\n  margin: unset;\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.agencySetting {\n  padding-bottom: 0;\n\n  h2 {\n    margin-bottom: 10px;\n    font-weight: 600 !important;\n  }\n}\n\n.tab {\n  border-bottom: 1px solid #c6c8cc !important;\n  span {\n    text-transform: none;\n    font-size: 17px;\n  }\n}\n.tabs {\n  margin-bottom: 6px !important;\n}\n\n.inputContainerPop {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.colorpickerContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 14px;\n  border: 1px solid #e0e2e6;\n  border-radius: 4px;\n  min-width: 123px;\n}\n\n.colorPickerInput {\n  input {\n    border: none !important;\n    font-size: 15px;\n    color: #1b2432;\n    letter-spacing: 0;\n    width: 85px;\n  }\n}\n\n.colorpickerError {\n  text-align: end;\n  font-size: 13px;\n  color: #ff0000;\n  margin-top: 3px;\n}\n\n.colorpickerErrorRow {\n  padding-bottom: 3px !important;\n}\n.colorpickerRowCont {\n  display: flex;\n  justify-content: space-between;\n\n  input {\n    width: 85px;\n    line-height: normal;\n  }\n}\n\n.pickerStyle {\n  position: absolute;\n  z-index: 9999;\n}\n\n.colorpickerRowText {\n  font-size: 15px;\n  color: #1b2432;\n  letter-spacing: 0;\n  margin-bottom: 9px;\n  font-weight: 600;\n}\n\n.colorpickerRowDescription {\n  font-size: 13px;\n  color: #1b2432;\n  letter-spacing: 0;\n}\n\n.colorpickerRow {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding-bottom: 24px;\n  padding-top: 24px;\n  border-bottom: 1px solid #d8d8d8;\n}\n\n.textFieldBox {\n  display:flex;\n  align-items: center;\n  margin-bottom: 10px;\n  position: relative;\n}\n\n.colorPreview {\n  width: 24px;\n  height: 24px; \n  border-radius: 4px;\n  margin-right: 5px;\n}\n\n.flexbox-fix:nth-of-type(3) {\n  display:none;\n}\n\n#rc-editable-input-1, \n#rc-editable-input-2,\n#rc-editable-input-3,\n#rc-editable-input-4, \n#rc-editable-input-5 {\n  width: 100% !important;\n}\n\n.colorpickerRow:last-child {\n  border-bottom: none !important;\n}\n\n.colorpickerRowTextContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n}\n\n.colorPickerStyle span {\n  border: none !important;\n  width: 24px !important;\n  height: 24px !important;\n  box-shadow: none !important;\n  border-radius: 4px !important;\n  display: block;\n}\n.colorPickerStyle {\n  height: 24px;\n  margin-right: 5px;\n}\n\n.companyInfoHeader {\n  display: flex;\n}\n\n.companyInfoHeaderText h2 {\n  font-size: 21px;\n  color: #1b2432;\n  letter-spacing: 0;\n  margin-bottom: 5px;\n}\n\n.companyInfoHeaderText .description {\n  font-size: 13px;\n  color: #6d717a;\n  letter-spacing: 0;\n}\n\n.companyInfoContainer {\n  border: 1px solid #dddee0;\n  border-radius: 4px;\n  padding-top: 25px;\n  padding-bottom: 17px;\n  padding-left: 20px;\n  padding-right: 20px;\n  margin-bottom: 32px;\n  margin-top: 18px;\n}\n\n.companyInfoContainerRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.contactInfoData {\n  display: flex;\n}\n\n.companyInfoColumn {\n  margin-right: 36px;\n\n  .descr {\n    &:first-child {\n      padding-bottom: 6px;\n    }\n  }\n}\n\n.contactContainer {\n  display: flex;\n}\n\n.contactButtonWrapper {\n  display: flex;\n  justify-content: flex-end;\n  flex: 1;\n}\n\n.companyInfoHeaderText {\n  font-size: 15px;\n  color: #1b2432;\n  letter-spacing: 0;\n  margin-left: 22px;\n}\n.companyInfoContainerDetails {\n  display: flex;\n  align-items: center;\n}\n\n.descr {\n  font-size: 13px;\n  color: #6d717a;\n  letter-spacing: 0;\n  line-height: 20px;\n  display: flex;\n  align-items: center;\n\n  p,\n  span {\n    color: #1b2432;\n    letter-spacing: 0;\n    padding-left: 5px;\n  }\n}\n\n.buttonEdit {\n  width: 55px;\n  min-width: 55px !important;\n}\n.companyInfoHeaderIconContainer {\n  background: #1b2432;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.companyInfoDescription {\n  text-align: left;\n  font-size: 15px;\n  color: #6d717a;\n  letter-spacing: 0;\n  padding: 0 32px 15px 32px;\n  font-family: 'Roboto';\n  width: 700px;\n}\n\n.popupButtonsContainer {\n  text-align: right;\n  margin-left: 32px;\n  margin-right: 32px;\n  padding: 32px 0;\n  border-top: 1px solid #d8d8d8;\n  margin-top: 28px;\n}\n\n.compPopupButton {\n  background: #318afb;\n  border-radius: 6px;\n  font-family: 'Roboto';\n  font-size: 17px;\n  color: #ffffff;\n  letter-spacing: 0;\n  width: 200px;\n  text-align: center;\n  height: 52px;\n}\n\n.dialogBox {\n  min-width: 700px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n\n  .title {\n    font-size: 29px;\n    color: #1b2432;\n    background-color: #fff;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex: 1 0 auto;\n    padding: 32px 32px 0;\n    padding-bottom: 12px;\n\n    .closeIcon {\n      position: absolute;\n      top: 18px;\n      right: 18px;\n\n      .svg {\n        font-size: 26px;\n      }\n    }\n  }\n\n  .container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    margin: 32px;\n    margin-bottom: 0px;\n    padding-bottom: 32px;\n    border-bottom: 1px solid #e0e2e6;\n\n    .textField {\n      margin: 18px 0 14px !important;\n    }\n  }\n\n  .inputContainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    padding-left: 30px;\n    padding-right: 30px;\n    max-width: 636px;\n    max-width: 700px;\n    margin-top: 0px;\n    margin-bottom: 0;\n    padding-bottom: 0;\n    font-family: 'Roboto';\n  }\n\n  .inputWrapper {\n    flex: 49% 0 1;\n    padding: 0;\n  }\n}\n\n.rateContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid rgba(224, 224, 224, 1);\n\n  .description {\n    font-size: 13px;\n    color: #1b2432;\n    font-weight: normal;\n    line-height: 11px;\n    margin-top: 8px;\n    margin-bottom: 13px;\n  }\n  .labelName {\n    legaline-height: 13px;\n    font-weight: 600;\n    font-size: 17px !important;\n    color: #1b2432 !important;\n  }\n}\n\n.disabledAgencyName {\n  font-family: Roboto;\n  font-style: italic;\n  font-size: 15px;\n  color: #1b2432;\n  letter-spacing: 0;\n}\n\n.companyInfoContainerDetails {\n  align-items: flex-start;\n  max-width: 600px;\n  flex-wrap: wrap;\n  flex-direction: column;\n\n  p {\n    margin-top: 4px !important;\n    margin-bottom: 4px !important;\n  }\n}\n\n.companyInfoAddress {\n  margin-top: 3px;\n}\n\n.companyInfoAddress .descr {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n}\n\n.companyInfoAddress .descr div {\n  display: flex;\n  line-height: 11px;\n}\n\n.companyInfoAddress .descr div:empty {\n  display: none;\n}\n\n.companyInfoAddress .descr .infCont {\n  flex-direction: column;\n}\n\n.informationTitleCompany {\n  margin-left: 32px;\n  margin-top: 25px;\n  margin-bottom: 10px;\n}\n\n.inputWrapper100 {\n  flex: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `components-AgencyDetails-styles___paper--YUUbv`,
	"paperMax": `components-AgencyDetails-styles___paperMax--zhF1Z`,
	"loading": `components-AgencyDetails-styles___loading--wjG7T`,
	"inputContainer": `components-AgencyDetails-styles___inputContainer--hoH9P`,
	"inputWrapper": `components-AgencyDetails-styles___inputWrapper--qzPRF`,
	"buttons": `components-AgencyDetails-styles___buttons--_j5xg`,
	"providerContainer": `components-AgencyDetails-styles___providerContainer--X8Sid`,
	"providerName": `components-AgencyDetails-styles___providerName--Tnr3G`,
	"providerTitle": `components-AgencyDetails-styles___providerTitle--pwnc8`,
	"switch": `components-AgencyDetails-styles___switch--xpzHM`,
	"tableCell": `components-AgencyDetails-styles___tableCell--XVO2p`,
	"description": `components-AgencyDetails-styles___description--Rpvmf`,
	"descriptionReimburs": `components-AgencyDetails-styles___descriptionReimburs--mIOM9`,
	"fraud": `components-AgencyDetails-styles___fraud--Exog5`,
	"fraudSelect": `components-AgencyDetails-styles___fraudSelect--u6ljx`,
	"marginNormal": `components-AgencyDetails-styles___marginNormal--zdgdb`,
	"recommended": `components-AgencyDetails-styles___recommended--nSRF0`,
	"recommendedItemContainer": `components-AgencyDetails-styles___recommendedItemContainer--QNElC`,
	"recommendedItemFraud": `components-AgencyDetails-styles___recommendedItemFraud--IqzS7`,
	"tableRow": `components-AgencyDetails-styles___tableRow--gGi9k`,
	"dialogBox": `components-AgencyDetails-styles___dialogBox--yVfuS`,
	"title": `components-AgencyDetails-styles___title--wOBrz`,
	"closeIcon": `components-AgencyDetails-styles___closeIcon--VmG3B`,
	"svg": `components-AgencyDetails-styles___svg--veHM1`,
	"popupBody": `components-AgencyDetails-styles___popupBody--etLN7`,
	"confirmationPopupButton": `components-AgencyDetails-styles___confirmationPopupButton--uVXLI`,
	"iOsBar": `components-AgencyDetails-styles___iOSBar--PcYCq`,
	"iOsBarOn": `components-AgencyDetails-styles___iOSBarON--kFDLz`,
	"disabled": `components-AgencyDetails-styles___disabled--u3A4u`,
	"iOsIcon": `components-AgencyDetails-styles___iOSIcon--rcxkn`,
	"iOsIconChecked": `components-AgencyDetails-styles___iOSIconChecked--MzTT7`,
	"iOsSwitchBase": `components-AgencyDetails-styles___iOSSwitchBase--npc_6`,
	"iOsChecked": `components-AgencyDetails-styles___iOSChecked--i3gqD`,
	"colorPrimary": `components-AgencyDetails-styles___colorPrimary--b5kJ2`,
	"loaderWrapper": `components-AgencyDetails-styles___loaderWrapper--U_oXd`,
	"buttonCell": `components-AgencyDetails-styles___buttonCell--GBeFB`,
	"component": `components-AgencyDetails-styles___component--jM1DF`,
	"agencySetting": `components-AgencyDetails-styles___agencySetting--askWB`,
	"tab": `components-AgencyDetails-styles___tab--ZhJqZ`,
	"tabs": `components-AgencyDetails-styles___tabs--tfMXg`,
	"inputContainerPop": `components-AgencyDetails-styles___inputContainerPop--VZfu2`,
	"colorpickerContainer": `components-AgencyDetails-styles___colorpickerContainer--CPH2k`,
	"colorPickerInput": `components-AgencyDetails-styles___colorPickerInput--QCgzH`,
	"colorpickerError": `components-AgencyDetails-styles___colorpickerError--QNlG_`,
	"colorpickerErrorRow": `components-AgencyDetails-styles___colorpickerErrorRow--F_I0y`,
	"colorpickerRowCont": `components-AgencyDetails-styles___colorpickerRowCont--zPMfC`,
	"pickerStyle": `components-AgencyDetails-styles___pickerStyle--EwN69`,
	"colorpickerRowText": `components-AgencyDetails-styles___colorpickerRowText--ZOwmf`,
	"colorpickerRowDescription": `components-AgencyDetails-styles___colorpickerRowDescription--NESJY`,
	"colorpickerRow": `components-AgencyDetails-styles___colorpickerRow--I35s9`,
	"textFieldBox": `components-AgencyDetails-styles___textFieldBox--w3fEL`,
	"colorPreview": `components-AgencyDetails-styles___colorPreview--_EITn`,
	"flexboxFix": `components-AgencyDetails-styles___flexbox-fix--wLueP`,
	"rcEditableInput1": `components-AgencyDetails-styles___rc-editable-input-1--uIGKM`,
	"rcEditableInput2": `components-AgencyDetails-styles___rc-editable-input-2--rYYSH`,
	"rcEditableInput3": `components-AgencyDetails-styles___rc-editable-input-3--Uvh0O`,
	"rcEditableInput4": `components-AgencyDetails-styles___rc-editable-input-4--azMXe`,
	"rcEditableInput5": `components-AgencyDetails-styles___rc-editable-input-5--zwAfE`,
	"colorpickerRowTextContainer": `components-AgencyDetails-styles___colorpickerRowTextContainer--xedrg`,
	"colorPickerStyle": `components-AgencyDetails-styles___colorPickerStyle--p83FE`,
	"companyInfoHeader": `components-AgencyDetails-styles___companyInfoHeader--e3q3i`,
	"companyInfoHeaderText": `components-AgencyDetails-styles___companyInfoHeaderText--xwMGf`,
	"companyInfoContainer": `components-AgencyDetails-styles___companyInfoContainer--wxrtB`,
	"companyInfoContainerRow": `components-AgencyDetails-styles___companyInfoContainerRow--jFIf0`,
	"contactInfoData": `components-AgencyDetails-styles___contactInfoData--L2hCD`,
	"companyInfoColumn": `components-AgencyDetails-styles___companyInfoColumn--pp9o7`,
	"descr": `components-AgencyDetails-styles___descr--KJCk1`,
	"contactContainer": `components-AgencyDetails-styles___contactContainer--YmAVO`,
	"contactButtonWrapper": `components-AgencyDetails-styles___contactButtonWrapper--anJN8`,
	"companyInfoContainerDetails": `components-AgencyDetails-styles___companyInfoContainerDetails--paCRH`,
	"buttonEdit": `components-AgencyDetails-styles___buttonEdit--cKnrm`,
	"companyInfoHeaderIconContainer": `components-AgencyDetails-styles___companyInfoHeaderIconContainer--fCLJL`,
	"companyInfoDescription": `components-AgencyDetails-styles___companyInfoDescription--bH_Zw`,
	"popupButtonsContainer": `components-AgencyDetails-styles___popupButtonsContainer--BBDNF`,
	"compPopupButton": `components-AgencyDetails-styles___compPopupButton--LQrE8`,
	"container": `components-AgencyDetails-styles___container--FAbFF`,
	"textField": `components-AgencyDetails-styles___textField--I5KRQ`,
	"rateContainer": `components-AgencyDetails-styles___rateContainer--wxljk`,
	"labelName": `components-AgencyDetails-styles___labelName--E5TVP`,
	"disabledAgencyName": `components-AgencyDetails-styles___disabledAgencyName--VAC2H`,
	"companyInfoAddress": `components-AgencyDetails-styles___companyInfoAddress--pe1QT`,
	"infCont": `components-AgencyDetails-styles___infCont--s7zTw`,
	"informationTitleCompany": `components-AgencyDetails-styles___informationTitleCompany--__Jel`,
	"inputWrapper100": `components-AgencyDetails-styles___inputWrapper100--Hr75c`
};
module.exports = ___CSS_LOADER_EXPORT___;
